

/**
 * This is the rsaVerify controller.
 * @memberOf securityquestion Module
 * @namespace rsaVerify Controller
 */

/**
 * @name rsaVerifyController
 * @desc Create the controller.
 * @param $scope
 * @param coreService
 * @memberOf securityquestion Module.rsaVerify Controller
 * @ngInject
 */
function rsaVerifyController($scope, $translate, coreService, deviceprintFn, whitelabel) {
    var vm = this;
    // Register the view model's properties.
    vm.validateForm = validateForm;
    vm.submitted = false;
    vm.messages = [];    

    // Activate the controller.
    activate();

    function activate() {
        // Read Identity Server's data model
        var model = coreService.getIdentityModel();

        if (model.custom && model.custom.ui_locales) {
            $translate.use(model.custom.ui_locales);
        }

        $scope.model = model;
        
        if(deviceprintFn !== null && deviceprintFn !== undefined && typeof deviceprintFn === 'function')
        {
          if(whitelabel !== null && whitelabel !== undefined && whitelabel === 'bmo')
          {
            $scope.device_print = deviceprintFn();
          }
        }
    }

    // Validate the login account form.
    function validateForm(e) {
        // Update the form.
        vm.messages = [];
        vm.submitted = true;

        if ($scope.challengeForm.$invalid) {
            // Move focus to first invalid input field
            var invalidInput = document.querySelector('input.ng-invalid');
            if (invalidInput) {
                invalidInput.focus();
            }
            // Do not submit
            e.preventDefault();
        }
    }
}

export default rsaVerifyController;


// WEBPACK FOOTER //
// ./src/login/securityquestion/rsa/verify/rsa.verify.controller.js